import { Routes, Route } from "react-router-dom";
import Dashboard from "./Dashboard/Dashboard";
import { Circles } from "react-loader-spinner";
import { Suspense, lazy, useState } from "react";
import CreateJobForm from "../Components/CreateJobForm/CreateJobForm";
import Sidenav from "../Components/Sidenav/Sidenav";
import Header from "../Components/Header/Header";
import MobileHeader from "../Components/MobileHeader/MobileHeader";
import SearchCv from "./SearchCv/SearchCv";
import ProfilePage from "./ProfilePage";
import SettingsPage from "./SettingsPage";
import MasterContextProvider, { useCreatedJobData } from "../context/MasterContextProvider";
import CustomDrawer from "../Components/CustomDrawer";
import JobForm from "../Components/CreateJobForm/JobForm";
import { Button, Dialog } from "@mui/material";
import { Close } from "@mui/icons-material";
import TickSVG from "../assets/redesign/tick-03.svg";
import { useNavigate } from "react-router-dom";
import "../Components/CreateJobForm/CreateJobForm.css";

const CreateJobs = lazy(() => import("./CreateJob/CreateJob"));
const JobApplications = lazy(
  () => import("../Components/Applications/Applications")
);
const JobApplicationsView = lazy(
  () => import("../Components/JobApplications/JobApplicationsView")
);
const JobsPosted = lazy(() => import("../Components/DashboardCard/jobsPosted"));

const Placements = lazy(() => import("../Components/Placements/Placements"));

// const SearchCv = lazy(() => import("./SearchCv/SearchCv"));

// Component that handles Create Job drawer
const JobDrawerHandler = () => {
  const { openCreateJob, setOpenCreateJob } = useCreatedJobData();
  const navigate = useNavigate();
  const [openDialog, setOpenDialog] = useState(false);

  const handleCloseDrawer = () => {
    setOpenCreateJob(false);
  };

  const handleDone = () => {
    handleCloseDrawer();
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleGoToJobs = () => {
    navigate("/dashboard/jobsposted");
    setOpenDialog(false);
  };

  const handleCreateNew = () => {
    setOpenDialog(false);
    setOpenCreateJob(true);
  };

  return (
    <>
      <CustomDrawer
        open={openCreateJob}
        onClose={handleCloseDrawer}
        title="Create Job"
      >
        <JobForm
          handleDone={handleDone}
          defaultValue={{
            jobName: "",
            jobDesc: "",
            jobReq: "",
            minSalary: 0,
            maxSalary: 0,
            currencyId: 1,
            currencyName: "AED",
            countryId: "",
            countryName: "United Arab Emirates",
            workStateId: "",
            workState: "",
            minExp: 0,
            maxExp: 5,
            jobLevel: "",
            jobLevelId: 0,
            jobType: "Full Time",
            industryId: 0,
            industryName: "",
            workTypeId: 0,
            workType: "",
            vacancy: 1,
            qualTypeId: 0,
            qualTypeName: "Bachelors",
            skills: [],
          }}
        />
      </CustomDrawer>

      <Dialog onClose={handleDialogClose} open={openDialog}>
        <div className="job_done_container">
          <Close onClick={handleDialogClose} className="dialog_close_btn" />
          <img src={TickSVG} />
          <h3>Your job post has been created successfully</h3>
          <Button onClick={handleGoToJobs}>Check jobs</Button>
          <br />
          <button onClick={handleCreateNew} className="secondaryNewBtn">
            Create another job post
          </button>
        </div>
      </Dialog>
    </>
  );
};

const Home = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <div className="main-layout">
      <MasterContextProvider>
        <JobDrawerHandler />
        <Sidenav 
          mobileOpen={mobileMenuOpen}
          onMobileToggle={handleMobileMenuToggle}
        />
        <div className="relative main_body_container_ak">
          <MobileHeader onMenuClick={handleMobileMenuToggle} />
          <Header />
          <Suspense
            fallback={
              <div className="home-box">
                <div className="content-inner-box">
                  <Circles
                    height="80"
                    width="80"
                    color="#1A9EE0"
                    ariaLabel="circles-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                  />
                </div>
              </div>
            }
          >
            <div className="main_body_layout">
              <Routes>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/dashboard/jobsposted" element={<JobsPosted />} />
                <Route
                  path="/dashboard/applications"
                  element={<JobApplications />}
                />
                <Route
                  path="/dashboard/jobs/:jobId/applications"
                  element={<JobApplicationsView />}
                />
                <Route path="/dashboard/placements" element={<Placements />} />

                <Route path="/createjob" element={<CreateJobs />} />
                <Route path="/createjob/drawer" element={<CreateJobForm />} />
                <Route path="/searchcv" element={<SearchCv />} />
                <Route path="/dashboard/profile" element={<ProfilePage />} />
                <Route path="/dashboard/settings" element={<SettingsPage />} />
              </Routes>
            </div>
          </Suspense>
        </div>
      </MasterContextProvider>
    </div>
  );
};

export default Home;
